import moment from 'moment';

const securityScore = value => (value ? Number(value).toFixed() : 0);

const date = (value, format = 'MMM DD, YYYY HH:mm') =>
    value ? moment(value).format(format) : null;

const onlydate = (value, format = 'MMM DD, YYYY') =>
    value ? moment(value).format(format) : null;

const MANAGED_BY_PASSWORD_BOSS = 'PB';

const displayName = (name, managed_by) =>
    managed_by === MANAGED_BY_PASSWORD_BOSS ? name : `${name} (AD)`;

// Display-only rebrand of the api's `managed_by` values (PBWA-2309). The api and
// the database still hold "PB" / "PB Partners"; only the rendered label changes.
//
// Keys are lowercased. The values cover both meanings the field carries: the
// management source on the Users/Groups tables ("PB"), and the parent
// organization's name on the Companies table ("PB Partners" and friends).
const MANAGED_BY_REBRAND = {
    pb: 'CyberFOX',
    'pb partners': 'CyberFOX Partners',
    'pb partner trials': 'CyberFOX Partner Trials',
    'pb donations': 'CyberFOX Donations',
};

// DO NOT apply this when receiving API data -- only when rendering a cell or a
// label. The raw values double as control values for the edit/select gating in
// GroupForm, UserForm, Groups, Users and UsersView (`managed_by === 'PB'`), and
// for filtering and search. Rewriting them in state silently mis-gates
// permissions with no error. See __tests__/formatters.test.js.
//
// Anything unmapped passes through untouched -- notably "Unmanaged" and
// connector names, which are org-configurable free text.
const managedByLabel = value => {
    // hasOwnProperty, not a bare lookup: connector names are org-configurable
    // free text, so a name like "toString" must not resolve to Object.prototype.
    const key = String(value ?? '').toLowerCase();
    return Object.prototype.hasOwnProperty.call(MANAGED_BY_REBRAND, key)
        ? MANAGED_BY_REBRAND[key]
        : value;
};

const PERCENT_FORMATER = 'percent';
const CURRENCY_FORMATER = 'currency';
const DECIMAL_FORMATER = 'decimal';

const formaters = new Map();

function getOrCreateFormater(name, locales, options) {
    const key = `${name}.${locales}`;
    if (!formaters.has(key)) {
        formaters.set(key, new Intl.NumberFormat(locales, options));
    }
    return formaters.get(key);
}

function getCurrencyFormatter(locales = 'en-US', currency = 'USD') {
    const name = `${CURRENCY_FORMATER}.${currency}`;
    return getOrCreateFormater(name, locales, {
        style: 'currency',
        currency,
    });
}

function getDecimalFormatter(locales = 'en-US') {
    return getOrCreateFormater(DECIMAL_FORMATER, locales, {
        style: 'decimal',
    });
}

function getPercentFormatter(locales = 'en-US') {
    return getOrCreateFormater(PERCENT_FORMATER, locales, {
        style: 'percent',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    });
}

export default {
    securityScore,
    date,
    onlydate,
    displayName,
    managedByLabel,
    getCurrencyFormatter,
    getDecimalFormatter,
    getPercentFormatter,
};
